import React, { useState, useEffect } from 'react';
import { getApiUrl } from '../../config/api';
import './AdminTables.css';

const AdminBookings = () => {
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) return;
    fetch(getApiUrl('/api/admin/bookings'), { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => r.json())
      .then((json) => {
        if (json.success) setBookings(json.bookings || []);
        else setError(json.message);
      })
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  }, []);

  if (loading && bookings.length === 0) {
    return (
      <div className="admin-page-loading">
        <div className="admin-spinner" />
        <p>Loading bookings...</p>
      </div>
    );
  }

  return (
    <div className="admin-page">
      <h2 className="admin-page-title">Booking Monitoring</h2>
      <p className="admin-page-subtitle">All stay bookings with guest, host and property mapping.</p>
      {error && <div className="admin-page-error">{error}</div>}
      <div className="admin-table-wrap">
        <table className="admin-table">
          <thead>
            <tr>
              <th>Booking ID</th>
              <th>Guest</th>
              <th>Property</th>
              <th>Host</th>
              <th>Check-in</th>
              <th>Check-out</th>
              <th>Amount</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {bookings.map((b) => (
              <tr key={b._id}>
                <td><code>{String(b._id).slice(-8)}</code></td>
                <td>{b.user?.name || b.user?.email || '—'}</td>
                <td>{b.property?.name || '—'}</td>
                <td>{b.host?.name || b.host?.email || '—'}</td>
                <td>{b.checkIn ? new Date(b.checkIn).toLocaleDateString() : '—'}</td>
                <td>{b.checkOut ? new Date(b.checkOut).toLocaleDateString() : '—'}</td>
                <td>₹{(b.totalPrice ?? 0).toLocaleString()}</td>
                <td><span className={`admin-badge status-${b.status}`}>{b.status}</span></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminBookings;
